import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { PurchaseFilterActionTypes, PurchaseFilterActions } from '../actions/purchase-filter.actions';


@Injectable()
export class PurchaseFilterEffects {
  private actions$ = inject(Actions);
  loadPurchaseFilters$ = createEffect(() => this.actions$.pipe(
    ofType(PurchaseFilterActionTypes.LoadPurchaseFilters),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor() {}

}
